export default __webpack_public_path__ + "static/media/down_tip_arrow.f61163bc.svg";